import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";

import { MAIN_DETAILS_CLASSES } from "~/components/store-details-page/components/main-details/constants";
import { TAG_CLASSES } from "~/components/tag/constants";
import { ChipType } from "~/theme/chip";
import * as colors from "~/theme/colors";
import {
  COLOR_BLACK,
  COLOR_GREYSCALE_BLACK_75,
  COLOR_NEON_GREEN,
} from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

export const MainDetailsContainer = styled(Container)(({ theme }) => {
  const { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } = getFormatMedia(theme);

  return {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(2),

    [BREAKPOINT_DESKTOP]: {
      marginBottom: theme.spacing(4),
    },

    [`& .${MAIN_DETAILS_CLASSES.card}`]: {
      padding: 0.1,
      [BREAKPOINT_DESKTOP]: {
        marginBottom: theme.spacing(6),
        position: "relative",
        height: 644,
        backgroundColor: colors.COLOR_ADDITIONAL_WARM_GRAY_3U,
        "& > .MuiGrid-container": { position: "absolute" },
      },
    },

    [`& .${MAIN_DETAILS_CLASSES.map}`]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      height: "100%",
      backgroundColor: "lightgrey",
      "& > div": { height: "100%", width: "100%" },
      "& > svg": { position: "absolute" },
    },

    [`& .${MAIN_DETAILS_CLASSES.info}`]: {
      position: "relative",
      padding: 0.1,
      [BREAKPOINT_DESKTOP]: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        margin: theme.spacing(3),
        marginLeft: theme.spacing(-6),
        padding: theme.spacing(3),
        paddingLeft: theme.spacing(6),
        height: `calc(100% - ${theme.spacing(6)})`,
        backgroundColor: "white",
      },
    },

    [`& .${MAIN_DETAILS_CLASSES.infoTitle}`]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(3),
      [BREAKPOINT_TABLET]: {
        marginBottom: theme.spacing(4),
      },
      [BREAKPOINT_DESKTOP]: {
        marginBottom: theme.spacing(2),
      },
    },

    [`& .${MAIN_DETAILS_CLASSES.clickAndCollectTrialStoreTag}`]: {
      marginBottom: theme.spacing(3),

      [`&.${TAG_CLASSES.chipTag}`]: {
        [`&.${ChipType.tag}`]: {
          backgroundColor: COLOR_NEON_GREEN,
          color: COLOR_BLACK,
          "&:hover": {
            color: COLOR_GREYSCALE_BLACK_75,
          },
        },
      },
      [BREAKPOINT_TABLET]: {
        marginBottom: theme.spacing(4),
      },
      [BREAKPOINT_DESKTOP]: {
        marginBottom: theme.spacing(2),
      },
    },

    [`& .${MAIN_DETAILS_CLASSES.infoLabel}`]: {
      marginBottom: theme.spacing(0.5),
      ...theme.typography.body2,
      color: colors.COLOR_GREYSCALE_BLACK_54,
      [BREAKPOINT_TABLET]: theme.typography.body1[`&.articleSmall`],
    },

    [`& .${MAIN_DETAILS_CLASSES.infoText}`]: {
      marginBottom: theme.spacing(3),
      ...theme.typography.body1,
      [BREAKPOINT_TABLET]: Object.assign(
        { marginBottom: theme.spacing(3) },
        theme.typography.body1["&.articleLarge"],
      ),
    },

    [`& .${MAIN_DETAILS_CLASSES.button}`]: {
      marginBottom: theme.spacing(3),
      width: "100%",
      [BREAKPOINT_TABLET]: {
        marginBottom: theme.spacing(4),
        width: "unset",
      },
      [BREAKPOINT_DESKTOP]: { marginBottom: theme.spacing(2) },
    },

    [`& .${MAIN_DETAILS_CLASSES.details}`]: {
      marginBottom: theme.spacing(3),
      [BREAKPOINT_TABLET]: { marginBottom: theme.spacing(4) },
    },

    [`& .${MAIN_DETAILS_CLASSES.detailsLabel}`]: {
      marginBottom: theme.spacing(0.5),
      color: colors.COLOR_GREYSCALE_BLACK_54,
      ...theme.typography.body2,
      [BREAKPOINT_TABLET]: {
        marginBottom: theme.spacing(1),
        ...theme.typography.body1,
      },
    },

    [`& .${MAIN_DETAILS_CLASSES.detailsText}`]: {
      display: "flex",
      alignItems: "center",
      ...theme.typography.body1,
      "& > svg": { marginLeft: theme.spacing(1) },
      "& ul": {
        margin: 0,
        paddingLeft: theme.spacing(3),
        [BREAKPOINT_TABLET]: {
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(2),
          paddingLeft: 0,
          listStyle: "none",
        },
      },
      "& li": {
        textTransform: "capitalize",
        "&::marker": {
          fontSize: 13,
        },
        "& svg": { display: "none" },
        [BREAKPOINT_TABLET]: {
          display: "flex",
          alignItems: "center",
          marginBottom: theme.spacing(2),
          "&:last-child": { marginBottom: 0 },
          "& svg": { display: "block", marginRight: theme.spacing(1) },
        },
      },
      [BREAKPOINT_TABLET]: theme.typography.body1["&.articleLarge"],
    },

    [`& .${MAIN_DETAILS_CLASSES.detailsTextLink}`]: {
      cursor: "pointer",
    },

    [`& .${MAIN_DETAILS_CLASSES.hours}`]: {
      display: "flex",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
      "& > div:first-of-type": { marginRight: theme.spacing(2) },
      [BREAKPOINT_TABLET]: { marginBottom: theme.spacing(4) },
    },

    [`& .${MAIN_DETAILS_CLASSES.hoursText}`]: {
      ...theme.typography.body1,
      [BREAKPOINT_TABLET]: theme.typography.body1["&.articleLarge"],
    },

    [`& .${MAIN_DETAILS_CLASSES.hoursCurrent}`]: {
      ...theme.typography.body1,
      fontWeight: 700,
      [BREAKPOINT_TABLET]: theme.typography.body1["&.articleLargeBold"],
    },

    [`& .${MAIN_DETAILS_CLASSES.hoursSpecial}`]: {
      marginTop: theme.spacing(1),
      padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
      backgroundColor: colors.COLOR_ADDITIONAL_WARM_GRAY_3U,
    },

    [`& .${MAIN_DETAILS_CLASSES.hoursSpecialText}`]: {
      ...theme.typography.body2,
      [BREAKPOINT_TABLET]: { ...theme.typography.body1 },
    },

    [`& .${MAIN_DETAILS_CLASSES.link}`]: {
      display: "flex",
      justifyContent: "space-between",
      padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
      textDecoration: "none",
      backgroundColor: colors.COLOR_ADDITIONAL_WARM_GRAY_3U,
      "&:not(:last-child)": { marginBottom: theme.spacing(0.5) },
    },

    [`& .${MAIN_DETAILS_CLASSES.linkText}`]: {
      ...theme.typography.body2,
      [BREAKPOINT_TABLET]: { ...theme.typography.body1 },
    },

    [`& .${MAIN_DETAILS_CLASSES.breadcrumbs}`]: {
      display: "block",
      "& a": {
        color: colors.COLOR_PRIMARY_BLACK,
      },
    },

    [`& .${MAIN_DETAILS_CLASSES.hideOnMobile}`]: {
      display: "none",
      [BREAKPOINT_DESKTOP]: {
        display: "block",
      },
    },
  };
});
